import React from 'react';
import { Zap } from 'lucide-react';
import { ModernHeader, ModernCard } from '../components/Modern';
import CRMDashboard from '../components/CRM/CRMDashboard';
import PageTransition from '../components/PageTransition';
import { useTheme } from '../contexts/ThemeContext';

const CRM = () => {
  const { isDarkMode } = useTheme();
  
  return (
    <PageTransition>
      <div className={`min-h-screen ${isDarkMode ? 'bg-gray-900' : 'bg-gray-50'} p-6`}>
        <div className="max-w-7xl mx-auto space-y-8">
          <ModernHeader 
            title="CRM" 
            subtitle="Gerenciamento de relacionamento com clientes" 
            icon={Zap}
            themeColor="purple"
          />
          
          <ModernCard className="p-0" themeColor="purple">
            <CRMDashboard />
          </ModernCard>
        </div>
      </div>
    </PageTransition>
  );
};

export default CRM;